var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B00000;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.3,23.7c0.3,0.3,0.7,0.5,1.2,0.5s0.8-0.2,1.2-0.5l8.9-8.9l8.9,8.9c0.3,0.3,0.8,0.5,1.2,0.5 c0.3,0,0.8-0.2,1.2-0.5c0.7-0.7,0.7-1.7,0-2.3l-8.9-8.9l8.9-8.9c0.7-0.7,0.7-1.7,0-2.3c-0.7-0.7-1.7-0.7-2.3,0l-8.9,8.9L3.6,1.3 c-0.7-0.7-1.7-0.7-2.3,0s-0.7,1.7,0,2.3l8.9,8.9l-8.9,8.9C0.6,22.1,0.6,23.1,1.3,23.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.bf6249772ea3e80fe5b9e9a640970106.svg";
export { ForwardRef as ReactComponent };